<template>
    <div class="flow">
        <div class="flow-container">
            <form class="flow-wrapper ui-table scroll-color">
                <table class="flow-table">
                    <thead>
                        <tr class="pl5-5">
                            <th width="20">&nbsp;</th>
                            <th width="105">Parcela</th>
                            <th width="155">Data de Juros</th>
                            <th width="71">Especificar Dia</th>
                            <th width="155">Data de Reajuste</th>
                            <th width="71">Especificar Dia</th>
                            <th width="100">Parcela de Referência</th>
                            <th width="20" />
                        </tr>
                    </thead>

                    <tbody>
                        <datesProposalTableItem
                            v-for="(item, index) in localInstallments"
                            :key="index"
                            :data="item"
                            :index="index"
                            :parcel-options="parcelOptions"
                            :proposal-dates-options="proposalDatesOptions"
                            :installment-list="installmentList"
                            @update-item="changeItemHandler"
                            @remove="removeItemHandler"
                        />
                    </tbody>
                </table>
            </form>

            <div class="flow-details">
                <ui-button design="light" @click="addEmptyItem()">
                    <i class="far fa-plus" aria-hidden="true" />
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import { currencyBRL } from '@/filters'
import datesProposalTableItem from '../dates-proposal-table-item'
import { uiButton } from '@/components/ui/buttons'

export default {
	name: 'ui-dates-proposal-table-flow',
	components: {
		uiButton,
		datesProposalTableItem,
	},
	filters: {
		currencyBRL,
	},

	props: {
		installmentList: {
			type: Array,
			default: () => [],
		},

		parcelOptions: {
			type: Array,
			default: () => [],
		},

		proposalDatesOptions: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			localInstallments: [...this.installmentList], // Criando cópia local
		}
	},

	watch: {
		// Sempre que a prop mudar, atualizar a cópia local
		installmentList: {
			handler(newList) {
				this.localInstallments = [...newList]
			},
			deep: true,
		},

		
	},

	methods: {
		addEmptyItem() {
			this.localInstallments.push({
				type: '',
				interest_date: '',
				interest_date_month: 0,
				interest_date_day: 0,
				readjustment_date: '',
				readjustment_date_month: 0,
				readjustment_date_day: 0,
				installment_ref: '',
			})
			this.emitUpdate()
		},

		removeItemHandler(index) {
			this.localInstallments.splice(index, 1)
			this.emitUpdate()
		},

		changeItemHandler(index, newData) {
			this.$set(this.localInstallments, index, newData)
			this.emitUpdate()
		},

		emitUpdate() {
			this.$root.$emit('update:installmentList', [...this.localInstallments])
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>
